/**
 * v12 API 兼容层：languages/zh-CN。
 *
 * v12 中 `import 'handsontable/languages/zh-CN'` 是一个副作用导入，
 * 导入即完成语言包注册，之后在 settings 里写 `language: 'zh-CN'` 生效。
 * v6 的语言包放在 i18n/languages/ 下且不会自动注册，这里补上注册动作，
 * 使业务侧的历史导入写法保持不变。
 */
import Handsontable from '../index';
import dictionary from '../i18n/languages/zh-CN';

Handsontable.languages.registerLanguageDictionary(dictionary);

export default dictionary;
